import{loadStripe as t}from"@stripe/stripe-js/pure/index.mjs";import{ref as r}from"vue";var e=r(),o=async()=>(e.value||(e.value=await t(import.meta.env.VITE_STRIPE_PUBLIC_KEY)),e.value);export{o as a};
